import { supabase } from '../../../foundation/altzero_base/base/utils/supabaseClient';

const API = (import.meta as { env: Record<string, string> }).env.VITE_API_URL ?? 'http://localhost:3001';

async function getHeaders(): Promise<Record<string, string>> {
  const { data: { session } } = await supabase.auth.getSession();
  return {
    'Content-Type': 'application/json',
    'x-api-key': 'scopingai',
    'Authorization': `Bearer ${session?.access_token ?? ''}`,
    'x-user-id': session?.user?.id ?? '',
  };
}

export type SfUser = {
  Id: string;
  Name: string;
  Email?: string;
  Phone?: string;
  MobilePhone?: string;
  Title?: string;
  Department?: string;
  Username?: string;
  IsActive?: boolean;
};

export const salesforceService = {
  getUserById: async (
    id: string,
  ): Promise<{ success: boolean; data?: SfUser; error?: string }> => {
    try {
      const res = await fetch(`${API}/api/salesforce/users/${encodeURIComponent(id)}`, {
        headers: await getHeaders(),
      });
      if (!res.ok) {
        const body: { error?: string } = await res.json().catch(() => ({}));
        return { success: false, error: body.error ?? `HTTP ${res.status}` };
      }
      const json: { success: boolean; data?: SfUser; error?: string } = await res.json();
      return { success: true, data: json.data };
    } catch (err) {
      return { success: false, error: (err as Error).message };
    }
  },

  getOpportunityAllFields: async (
    id: string,
  ): Promise<{ success: boolean; data?: Record<string, unknown>; error?: string }> => {
    try {
      const res = await fetch(`${API}/api/salesforce/opportunities/${encodeURIComponent(id)}/all`, {
        headers: await getHeaders(),
      });
      if (!res.ok) {
        const body: { error?: string } = await res.json().catch(() => ({}));
        return { success: false, error: body.error ?? `HTTP ${res.status}` };
      }
      const json: { success: boolean; data?: Record<string, unknown>; error?: string } = await res.json();
      return { success: true, data: json.data };
    } catch (err) {
      return { success: false, error: (err as Error).message };
    }
  },

  /** Refresh many sites from Salesforce; resolves once every site is done — no run persisted. */
  bulkRefresh: async (
    siteIds: string[],
  ): Promise<{ success: boolean; data?: { results: SfBulkRefreshResult[] }; error?: string }> => {
    try {
      const res = await fetch(`${API}/api/salesforce/sync-site/bulk`, {
        method: 'POST',
        headers: await getHeaders(),
        body: JSON.stringify({ site_ids: siteIds }),
      });
      const json: { success: boolean; data?: { results: SfBulkRefreshResult[] }; error?: string } = await res.json();
      if (!res.ok || !json.success) return { success: false, error: json.error ?? `HTTP ${res.status}` };
      return { success: true, data: json.data };
    } catch (err) {
      return { success: false, error: (err as Error).message };
    }
  },
};

export type SfBulkRefreshResult = { site_id: string; nmi: string | null; success: boolean; error?: string };
